import { useApprovalConditions } from './useApprovalConditions';
import { useApprovalContext } from './useApprovalContext';
import { ApprovalOperation } from 'ui-product-approvals-common';
import { canRequestChanges } from '../utils/canRequestChanges';
export const useHasLegacyRequestChangesCommentButton = ({
  hasLegacyCommentDestination
}) => {
  const approval = useApprovalContext();
  const {
    isPending
  } = useApprovalConditions();
  const {
    approvalType,
    availableOperations
  } = approval.meta;

  // The modern REQUEST_CHANGES flow renders its own button — never show both.
  if (availableOperations.includes(ApprovalOperation.REQUEST_CHANGES)) {
    return false;
  }

  // Otherwise show the legacy button only when there is a destination and the
  // user can actually request changes on this pending approval.
  return hasLegacyCommentDestination && isPending && availableOperations.includes(ApprovalOperation.APPROVE) && canRequestChanges({
    approvalType
  });
};